import {
  Dropdown as NextUIDropdown,
  DropdownItem as NextUIDropdownItem,
  DropdownMenu as NextUIDropdownMenu,
  DropdownTrigger as NextUIDropdownTrigger,
  DropdownSection as NextUIDropdownSection,
} from '@heroui/dropdown';
import { extendVariants } from '@heroui/react';

export const Dropdown = (props: React.ComponentProps<typeof NextUIDropdown>) => (
  <NextUIDropdown
    className="rounded-md"
    classNames={{ content: 'px-0 py-1.25 rounded-md border border-divider shadow-lg bg-content2' }}
    {...props}
  />
);

export const DropdownTrigger = extendVariants(NextUIDropdownTrigger, {});

export const DropdownMenu = (props: React.ComponentProps<typeof NextUIDropdownMenu>) => (
  <NextUIDropdownMenu
    className="p-0!"
    classNames={{ list: 'gap-1' }}
    itemClasses={{
      base: [
        'rounded-none',
        'py-1.5',
        'px-4',
        'text-default-700',
        'bg-content2',
        'data-[hover=true]:text-default-700',
        'data-[hover=true]:bg-content3',
        'data-[selectable=true]:focus:bg-dummy',
        'hover:border-transparent',
      ],
    }}
    {...props}
  />
);

export const DropdownItem = extendVariants(NextUIDropdownItem, {});

export const DropdownSection = extendVariants(NextUIDropdownSection, {
  slots: {
    heading: 'uppercase font-medium text-default-500 px-4 py-2 text-sm',
  },
});
